import styled from "styled-components";

export const MuiInfoToolTipWrapper = styled.div`
  margin-left: 8px;
  .error-icon {
    display: flex;
    flex-direction: row;
  }
`;
